/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const CreateView = /* GraphQL */ `mutation CreateView($input: CreateViewRequest!) {
  CreateView(input: $input) {
    id
    error {
      message
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateViewMutationVariables,
  APITypes.CreateViewMutation
>;
export const UpdateView = /* GraphQL */ `mutation UpdateView($input: UpdateViewRequest!) {
  UpdateView(input: $input) {
    id
    error {
      message
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateViewMutationVariables,
  APITypes.UpdateViewMutation
>;
export const createReview = /* GraphQL */ `mutation CreateReview($input: CreateReviewInput!) {
  createReview(input: $input) {
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReviewMutationVariables,
  APITypes.CreateReviewMutation
>;
export const createSystem = /* GraphQL */ `mutation CreateSystem($input: CreateSystemInput!) {
  createSystem(input: $input) {
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSystemMutationVariables,
  APITypes.CreateSystemMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const addComment = /* GraphQL */ `mutation AddComment($input: AddCommentInput!) {
  addComment(input: $input) {
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddCommentMutationVariables,
  APITypes.AddCommentMutation
>;
export const manageReview = /* GraphQL */ `mutation ManageReview($input: ManageReviewRequest!) {
  manageReview(input: $input) {
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ManageReviewMutationVariables,
  APITypes.ManageReviewMutation
>;
export const manageReviewerReview = /* GraphQL */ `mutation ManageReviewerReview($input: ManageReviewerReviewRequest!) {
  manageReviewerReview(input: $input) {
    status
    review {
      reviewId
      reviewStatus
      reviewJson
      system
      timestamp
      requesterId
      resourceIdentifier
      reviewers
      reviewDescription
      reviewedTimestamp
      __typename
    }
    reviewStatus
    configStatus
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ManageReviewerReviewMutationVariables,
  APITypes.ManageReviewerReviewMutation
>;
export const createConfiguration = /* GraphQL */ `mutation CreateConfiguration($input: CreateConfigWithReviewInput!) {
  createConfiguration(input: $input) {
    reviewStatus
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateConfigurationMutationVariables,
  APITypes.CreateConfigurationMutation
>;
export const createVersion = /* GraphQL */ `mutation CreateVersion($input: CreateVersionWithReviewInput!) {
  createVersion(input: $input) {
    reviewStatus
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateVersionMutationVariables,
  APITypes.CreateVersionMutation
>;
export const CreateSandbox = /* GraphQL */ `mutation CreateSandbox($userAlias: String!, $request: CreateSandboxRequest!) {
  CreateSandbox(userAlias: $userAlias, request: $request) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    created_at
    status
    sandbox_name
    allocation_types
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSandboxMutationVariables,
  APITypes.CreateSandboxMutation
>;
export const UpdateSandbox = /* GraphQL */ `mutation UpdateSandbox(
  $userAlias: String!
  $sandbox_id: String!
  $request: UpdateSandboxRequest!
) {
  UpdateSandbox(
    userAlias: $userAlias
    sandbox_id: $sandbox_id
    request: $request
  ) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    created_at
    status
    sandbox_name
    allocation_types
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSandboxMutationVariables,
  APITypes.UpdateSandboxMutation
>;
export const DeprecateSandbox = /* GraphQL */ `mutation DeprecateSandbox($userAlias: String!, $sandbox_id: String!) {
  DeprecateSandbox(userAlias: $userAlias, sandbox_id: $sandbox_id) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    created_at
    status
    sandbox_name
    allocation_types
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeprecateSandboxMutationVariables,
  APITypes.DeprecateSandboxMutation
>;
export const ReviveSandbox = /* GraphQL */ `mutation ReviveSandbox($userAlias: String!, $sandbox_id: String!) {
  ReviveSandbox(userAlias: $userAlias, sandbox_id: $sandbox_id) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    created_at
    status
    sandbox_name
    allocation_types
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ReviveSandboxMutationVariables,
  APITypes.ReviveSandboxMutation
>;
export const DisableSandbox = /* GraphQL */ `mutation DisableSandbox($userAlias: String!, $sandbox_id: String!) {
  DisableSandbox(userAlias: $userAlias, sandbox_id: $sandbox_id) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    created_at
    status
    sandbox_name
    allocation_types
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DisableSandboxMutationVariables,
  APITypes.DisableSandboxMutation
>;
export const EnableSandbox = /* GraphQL */ `mutation EnableSandbox($userAlias: String!, $sandbox_id: String!) {
  EnableSandbox(userAlias: $userAlias, sandbox_id: $sandbox_id) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    created_at
    status
    sandbox_name
    allocation_types
    __typename
  }
}
` as GeneratedMutation<
  APITypes.EnableSandboxMutationVariables,
  APITypes.EnableSandboxMutation
>;
export const CreateInputMetadataForSimulation = /* GraphQL */ `mutation CreateInputMetadataForSimulation(
  $sandbox_id: String!
  $sim_id: String!
  $input_type: InputType!
  $userAlias: String!
  $config: String
) {
  CreateInputMetadataForSimulation(
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    input_type: $input_type
    userAlias: $userAlias
    config: $config
  ) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    name
    status
    created_at
    updated_at
    started_at
    finished_at
    error_msg
    configs
    allocation_type
    input_ids
    mwaa_env
    dag_run_id
    scenario
    timeRange
    dag_tasks_status
    report_id
    is_shared
    userAlias
    created_by
    updated_by
    started_by
    is_input_selected
    published_to_fpaone
    fpaone_publish_status
    sandbox_name
    shared_to_sandbox_ids
    shared_from_sandbox_id
    shared_from_sandbox_name
    comments
    allocation_pools
    ticket_id
    simulation_tag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInputMetadataForSimulationMutationVariables,
  APITypes.CreateInputMetadataForSimulationMutation
>;
export const UpdateInputMetadata = /* GraphQL */ `mutation UpdateInputMetadata($s3_path: String!) {
  UpdateInputMetadata(s3_path: $s3_path) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    created_at
    status
    input_type
    allocation_type
    s3_path
    userAlias
    dictionary_input_id
    source_id
    source_type
    configs
    sim_resource_key
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInputMetadataMutationVariables,
  APITypes.UpdateInputMetadataMutation
>;
export const DeprecateInput = /* GraphQL */ `mutation DeprecateInput($sandbox_id: String!, $input_id: String!) {
  DeprecateInput(sandbox_id: $sandbox_id, input_id: $input_id) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    created_at
    status
    input_type
    allocation_type
    s3_path
    userAlias
    dictionary_input_id
    source_id
    source_type
    configs
    sim_resource_key
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeprecateInputMutationVariables,
  APITypes.DeprecateInputMutation
>;
export const ReviveInput = /* GraphQL */ `mutation ReviveInput($sandbox_id: String!, $input_id: String!) {
  ReviveInput(sandbox_id: $sandbox_id, input_id: $input_id) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    created_at
    status
    input_type
    allocation_type
    s3_path
    userAlias
    dictionary_input_id
    source_id
    source_type
    configs
    sim_resource_key
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ReviveInputMutationVariables,
  APITypes.ReviveInputMutation
>;
export const CreateLinkInput = /* GraphQL */ `mutation CreateLinkInput(
  $userAlias: String!
  $s3_path: String!
  $sim_id: String
  $sandbox_id: String!
  $input_type: InputType
  $name: String!
  $configs: String!
) {
  CreateLinkInput(
    userAlias: $userAlias
    s3_path: $s3_path
    sim_id: $sim_id
    sandbox_id: $sandbox_id
    input_type: $input_type
    name: $name
    configs: $configs
  ) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    name
    status
    created_at
    updated_at
    started_at
    finished_at
    error_msg
    configs
    allocation_type
    input_ids
    mwaa_env
    dag_run_id
    scenario
    timeRange
    dag_tasks_status
    report_id
    is_shared
    userAlias
    created_by
    updated_by
    started_by
    is_input_selected
    published_to_fpaone
    fpaone_publish_status
    sandbox_name
    shared_to_sandbox_ids
    shared_from_sandbox_id
    shared_from_sandbox_name
    comments
    allocation_pools
    ticket_id
    simulation_tag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLinkInputMutationVariables,
  APITypes.CreateLinkInputMutation
>;
export const CreateSim = /* GraphQL */ `mutation CreateSim($sandbox_id: String!, $request: CreateSimRequest!) {
  CreateSim(sandbox_id: $sandbox_id, request: $request) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    name
    status
    created_at
    updated_at
    started_at
    finished_at
    error_msg
    configs
    allocation_type
    input_ids
    mwaa_env
    dag_run_id
    scenario
    timeRange
    dag_tasks_status
    report_id
    is_shared
    userAlias
    created_by
    updated_by
    started_by
    is_input_selected
    published_to_fpaone
    fpaone_publish_status
    sandbox_name
    shared_to_sandbox_ids
    shared_from_sandbox_id
    shared_from_sandbox_name
    comments
    allocation_pools
    ticket_id
    simulation_tag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSimMutationVariables,
  APITypes.CreateSimMutation
>;
export const StartSim = /* GraphQL */ `mutation StartSim($sandbox_id: String!, $sim_id: String!, $userAlias: String!) {
  StartSim(sandbox_id: $sandbox_id, sim_id: $sim_id, userAlias: $userAlias) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    name
    status
    created_at
    updated_at
    started_at
    finished_at
    error_msg
    configs
    allocation_type
    input_ids
    mwaa_env
    dag_run_id
    scenario
    timeRange
    dag_tasks_status
    report_id
    is_shared
    userAlias
    created_by
    updated_by
    started_by
    is_input_selected
    published_to_fpaone
    fpaone_publish_status
    sandbox_name
    shared_to_sandbox_ids
    shared_from_sandbox_id
    shared_from_sandbox_name
    comments
    allocation_pools
    ticket_id
    simulation_tag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartSimMutationVariables,
  APITypes.StartSimMutation
>;
export const ReStartSim = /* GraphQL */ `mutation ReStartSim(
  $sandbox_id: String!
  $sim_id: String!
  $userAlias: String!
) {
  ReStartSim(sandbox_id: $sandbox_id, sim_id: $sim_id, userAlias: $userAlias) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    name
    status
    created_at
    updated_at
    started_at
    finished_at
    error_msg
    configs
    allocation_type
    input_ids
    mwaa_env
    dag_run_id
    scenario
    timeRange
    dag_tasks_status
    report_id
    is_shared
    userAlias
    created_by
    updated_by
    started_by
    is_input_selected
    published_to_fpaone
    fpaone_publish_status
    sandbox_name
    shared_to_sandbox_ids
    shared_from_sandbox_id
    shared_from_sandbox_name
    comments
    allocation_pools
    ticket_id
    simulation_tag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ReStartSimMutationVariables,
  APITypes.ReStartSimMutation
>;
export const CancelSim = /* GraphQL */ `mutation CancelSim(
  $sandbox_id: String!
  $sim_id: String!
  $userAlias: String!
) {
  CancelSim(sandbox_id: $sandbox_id, sim_id: $sim_id, userAlias: $userAlias) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    name
    status
    created_at
    updated_at
    started_at
    finished_at
    error_msg
    configs
    allocation_type
    input_ids
    mwaa_env
    dag_run_id
    scenario
    timeRange
    dag_tasks_status
    report_id
    is_shared
    userAlias
    created_by
    updated_by
    started_by
    is_input_selected
    published_to_fpaone
    fpaone_publish_status
    sandbox_name
    shared_to_sandbox_ids
    shared_from_sandbox_id
    shared_from_sandbox_name
    comments
    allocation_pools
    ticket_id
    simulation_tag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CancelSimMutationVariables,
  APITypes.CancelSimMutation
>;
export const DeprecateSim = /* GraphQL */ `mutation DeprecateSim(
  $sandbox_id: String!
  $sim_id: String!
  $is_shared: Boolean
  $userAlias: String!
) {
  DeprecateSim(
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    is_shared: $is_shared
    userAlias: $userAlias
  ) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    name
    status
    created_at
    updated_at
    started_at
    finished_at
    error_msg
    configs
    allocation_type
    input_ids
    mwaa_env
    dag_run_id
    scenario
    timeRange
    dag_tasks_status
    report_id
    is_shared
    userAlias
    created_by
    updated_by
    started_by
    is_input_selected
    published_to_fpaone
    fpaone_publish_status
    sandbox_name
    shared_to_sandbox_ids
    shared_from_sandbox_id
    shared_from_sandbox_name
    comments
    allocation_pools
    ticket_id
    simulation_tag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeprecateSimMutationVariables,
  APITypes.DeprecateSimMutation
>;
export const ReviveSim = /* GraphQL */ `mutation ReviveSim(
  $sandbox_id: String!
  $sim_id: String!
  $is_shared: Boolean
  $userAlias: String!
) {
  ReviveSim(
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    is_shared: $is_shared
    userAlias: $userAlias
  ) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    name
    status
    created_at
    updated_at
    started_at
    finished_at
    error_msg
    configs
    allocation_type
    input_ids
    mwaa_env
    dag_run_id
    scenario
    timeRange
    dag_tasks_status
    report_id
    is_shared
    userAlias
    created_by
    updated_by
    started_by
    is_input_selected
    published_to_fpaone
    fpaone_publish_status
    sandbox_name
    shared_to_sandbox_ids
    shared_from_sandbox_id
    shared_from_sandbox_name
    comments
    allocation_pools
    ticket_id
    simulation_tag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ReviveSimMutationVariables,
  APITypes.ReviveSimMutation
>;
export const UpdateSim = /* GraphQL */ `mutation UpdateSim(
  $sandbox_id: String!
  $sim_id: String!
  $request: UpdateSimRequest!
) {
  UpdateSim(sandbox_id: $sandbox_id, sim_id: $sim_id, request: $request) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    name
    status
    created_at
    updated_at
    started_at
    finished_at
    error_msg
    configs
    allocation_type
    input_ids
    mwaa_env
    dag_run_id
    scenario
    timeRange
    dag_tasks_status
    report_id
    is_shared
    userAlias
    created_by
    updated_by
    started_by
    is_input_selected
    published_to_fpaone
    fpaone_publish_status
    sandbox_name
    shared_to_sandbox_ids
    shared_from_sandbox_id
    shared_from_sandbox_name
    comments
    allocation_pools
    ticket_id
    simulation_tag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSimMutationVariables,
  APITypes.UpdateSimMutation
>;
export const UpdateSimStatus = /* GraphQL */ `mutation UpdateSimStatus(
  $sandbox_id: String!
  $sim_id: String!
  $request: UpdateSimStatusRequest!
) {
  UpdateSimStatus(sandbox_id: $sandbox_id, sim_id: $sim_id, request: $request) {
    sandbox_id
    resource_key
    status_key
    resource_id
    resource_type
    is_active
    name
    status
    created_at
    updated_at
    started_at
    finished_at
    error_msg
    configs
    allocation_type
    input_ids
    mwaa_env
    dag_run_id
    scenario
    timeRange
    dag_tasks_status
    report_id
    is_shared
    userAlias
    created_by
    updated_by
    started_by
    is_input_selected
    published_to_fpaone
    fpaone_publish_status
    sandbox_name
    shared_to_sandbox_ids
    shared_from_sandbox_id
    shared_from_sandbox_name
    comments
    allocation_pools
    ticket_id
    simulation_tag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSimStatusMutationVariables,
  APITypes.UpdateSimStatusMutation
>;
export const ShareSim = /* GraphQL */ `mutation ShareSim(
  $sandbox_id: String!
  $sim_id: String!
  $request: ShareSimRequest!
) {
  ShareSim(sandbox_id: $sandbox_id, sim_id: $sim_id, request: $request)
}
` as GeneratedMutation<
  APITypes.ShareSimMutationVariables,
  APITypes.ShareSimMutation
>;
export const ShareSimToRFA = /* GraphQL */ `mutation ShareSimToRFA(
  $sandbox_id: String!
  $sim_id: String!
  $userAlias: String!
  $comments: String!
  $simulation_tag: String
) {
  ShareSimToRFA(
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    userAlias: $userAlias
    comments: $comments
    simulation_tag: $simulation_tag
  )
}
` as GeneratedMutation<
  APITypes.ShareSimToRFAMutationVariables,
  APITypes.ShareSimToRFAMutation
>;
export const UnshareSimFromSandbox = /* GraphQL */ `mutation UnshareSimFromSandbox(
  $sandbox_id: String!
  $sim_id: String!
  $request: ShareSimRequest!
) {
  UnshareSimFromSandbox(
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    request: $request
  )
}
` as GeneratedMutation<
  APITypes.UnshareSimFromSandboxMutationVariables,
  APITypes.UnshareSimFromSandboxMutation
>;
export const UpdateConfiguration = /* GraphQL */ `mutation UpdateConfiguration(
  $userAlias: String!
  $content: String!
  $configType: ConfigType!
) {
  UpdateConfiguration(
    userAlias: $userAlias
    content: $content
    configType: $configType
  ) {
    content
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateConfigurationMutationVariables,
  APITypes.UpdateConfigurationMutation
>;
export const CreateScenario = /* GraphQL */ `mutation CreateScenario($userAlias: String!, $request: CreateScenarioRequest!) {
  CreateScenario(userAlias: $userAlias, request: $request) {
    scenario_name
    start_period
    end_period
    default_public
    created_at
    status
    status_key
    resource_key
    display_period
    resource_id
    sandbox_id
    allocation_type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateScenarioMutationVariables,
  APITypes.CreateScenarioMutation
>;
export const UpdateScenario = /* GraphQL */ `mutation UpdateScenario($userAlias: String!, $request: UpdateScenarioRequest!) {
  UpdateScenario(userAlias: $userAlias, request: $request) {
    scenario_name
    start_period
    end_period
    default_public
    created_at
    status
    status_key
    resource_key
    display_period
    resource_id
    sandbox_id
    allocation_type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateScenarioMutationVariables,
  APITypes.UpdateScenarioMutation
>;
export const EnableScenario = /* GraphQL */ `mutation EnableScenario($userAlias: String!, $request: EnableScenarioRequest!) {
  EnableScenario(userAlias: $userAlias, request: $request) {
    scenario_name
    start_period
    end_period
    default_public
    created_at
    status
    status_key
    resource_key
    display_period
    resource_id
    sandbox_id
    allocation_type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.EnableScenarioMutationVariables,
  APITypes.EnableScenarioMutation
>;
export const DisableScenario = /* GraphQL */ `mutation DisableScenario(
  $userAlias: String!
  $request: DisableScenarioRequest!
) {
  DisableScenario(userAlias: $userAlias, request: $request) {
    scenario_name
    start_period
    end_period
    default_public
    created_at
    status
    status_key
    resource_key
    display_period
    resource_id
    sandbox_id
    allocation_type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DisableScenarioMutationVariables,
  APITypes.DisableScenarioMutation
>;
export const SelectSimulationInput = /* GraphQL */ `mutation SelectSimulationInput(
  $sandbox_id: String!
  $sim_id: String!
  $input_type: InputType
  $inputs: String
  $userAlias: String
) {
  SelectSimulationInput(
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    input_type: $input_type
    inputs: $inputs
    userAlias: $userAlias
  )
}
` as GeneratedMutation<
  APITypes.SelectSimulationInputMutationVariables,
  APITypes.SelectSimulationInputMutation
>;
export const NotifyUploadStatus = /* GraphQL */ `mutation NotifyUploadStatus(
  $sim_id: String!
  $metadata_id: String!
  $status: UploadStatus!
  $validateError: [String]
  $errorDownloadUrl: String
) {
  NotifyUploadStatus(
    sim_id: $sim_id
    metadata_id: $metadata_id
    status: $status
    validateError: $validateError
    errorDownloadUrl: $errorDownloadUrl
  ) {
    status
    validateError
    errorDownloadUrl
    __typename
  }
}
` as GeneratedMutation<
  APITypes.NotifyUploadStatusMutationVariables,
  APITypes.NotifyUploadStatusMutation
>;
export const CloneInputData = /* GraphQL */ `mutation CloneInputData(
  $sandbox_id: String!
  $sim_id: String!
  $costpool_ids: [String]
  $input_reference: CustomDriverInput
  $timePeriod: [String]
  $userAlias: String
) {
  CloneInputData(
    sandbox_id: $sandbox_id
    sim_id: $sim_id
    costpool_ids: $costpool_ids
    input_reference: $input_reference
    timePeriod: $timePeriod
    userAlias: $userAlias
  )
}
` as GeneratedMutation<
  APITypes.CloneInputDataMutationVariables,
  APITypes.CloneInputDataMutation
>;
export const PublishSim = /* GraphQL */ `mutation PublishSim(
  $sandbox_id: String!
  $sim_id: String!
  $userAlias: String!
) {
  PublishSim(sandbox_id: $sandbox_id, sim_id: $sim_id, userAlias: $userAlias)
}
` as GeneratedMutation<
  APITypes.PublishSimMutationVariables,
  APITypes.PublishSimMutation
>;
export const UnpublishSim = /* GraphQL */ `mutation UnpublishSim(
  $sandbox_id: String!
  $sim_id: String!
  $userAlias: String!
) {
  UnpublishSim(sandbox_id: $sandbox_id, sim_id: $sim_id, userAlias: $userAlias)
}
` as GeneratedMutation<
  APITypes.UnpublishSimMutationVariables,
  APITypes.UnpublishSimMutation
>;
export const DownloadSimulationInput = /* GraphQL */ `mutation DownloadSimulationInput(
  $input_id: String!
  $sandbox_id: String!
  $user: String
  $download_type: DownloadType
) {
  DownloadSimulationInput(
    input_id: $input_id
    sandbox_id: $sandbox_id
    user: $user
    download_type: $download_type
  ) {
    download_url
    error_msg
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DownloadSimulationInputMutationVariables,
  APITypes.DownloadSimulationInputMutation
>;
export const StartFileUpload = /* GraphQL */ `mutation StartFileUpload($input: StartFileUploadInput!) {
  StartFileUpload(input: $input) {
    metaDataId
    Url
    message
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartFileUploadMutationVariables,
  APITypes.StartFileUploadMutation
>;
export const LinkFileUpload = /* GraphQL */ `mutation LinkFileUpload($input: LinkFileUploadInput!) {
  LinkFileUpload(input: $input) {
    status
    costpoolCount
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LinkFileUploadMutationVariables,
  APITypes.LinkFileUploadMutation
>;
export const NotifyFileUploadStatus = /* GraphQL */ `mutation NotifyFileUploadStatus(
  $metadataId: String!
  $simulationKey: String!
  $status: String!
  $errors: [String]
) {
  NotifyFileUploadStatus(
    metadataId: $metadataId
    simulationKey: $simulationKey
    status: $status
    errors: $errors
  ) {
    metadataId
    simulationKey
    status
    errors
    __typename
  }
}
` as GeneratedMutation<
  APITypes.NotifyFileUploadStatusMutationVariables,
  APITypes.NotifyFileUploadStatusMutation
>;
export const DownloadCostPoolDetails = /* GraphQL */ `mutation DownloadCostPoolDetails(
  $costPoolId: String!
  $costPoolVersionId: Int!
  $driverVersionId: Int!
) {
  DownloadCostPoolDetails(
    costPoolId: $costPoolId
    costPoolVersionId: $costPoolVersionId
    driverVersionId: $driverVersionId
  ) {
    download_url
    error_msg
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DownloadCostPoolDetailsMutationVariables,
  APITypes.DownloadCostPoolDetailsMutation
>;
export const CancelFileUpload = /* GraphQL */ `mutation CancelFileUpload($input: CancelFileUploadInput!) {
  CancelFileUpload(input: $input) {
    status
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CancelFileUploadMutationVariables,
  APITypes.CancelFileUploadMutation
>;
export const createConfigurationInDataStore = /* GraphQL */ `mutation CreateConfigurationInDataStore($input: CreateConfigurationRequest!) {
  createConfigurationInDataStore(input: $input) {
    string
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateConfigurationInDataStoreMutationVariables,
  APITypes.CreateConfigurationInDataStoreMutation
>;
export const createVersionInDataStore = /* GraphQL */ `mutation CreateVersionInDataStore($input: CreateConfigurationRequest!) {
  createVersionInDataStore(input: $input) {
    string
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateVersionInDataStoreMutationVariables,
  APITypes.CreateVersionInDataStoreMutation
>;
export const createTenant = /* GraphQL */ `mutation CreateTenant($input: CreateTenantRequest!) {
  createTenant(input: $input) {
    string
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTenantMutationVariables,
  APITypes.CreateTenantMutation
>;
export const ValidateAndExport = /* GraphQL */ `mutation ValidateAndExport($input: ValidateAndExportRequest) {
  ValidateAndExport(input: $input) {
    errors {
      rowNumber
      attributeName
      attributeValue
      errorMessage
      suggestion
      __typename
    }
    dataTarget {
      dataTargetType
      filePath
      __typename
    }
    status
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ValidateAndExportMutationVariables,
  APITypes.ValidateAndExportMutation
>;
export const CancelStepFunction = /* GraphQL */ `mutation CancelStepFunction($input: CancelStepFunctionRequest!) {
  CancelStepFunction(input: $input) {
    status
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CancelStepFunctionMutationVariables,
  APITypes.CancelStepFunctionMutation
>;
export const createGFTOneNotificationRequest = /* GraphQL */ `mutation CreateGFTOneNotificationRequest(
  $input: CreateGFTOneNotificationRequestInput!
) {
  createGFTOneNotificationRequest(input: $input) {
    allNotifications {
      id
      app
      channel
      stage
      recipients
      notificationType
      isSplitGroup
      sender
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGFTOneNotificationRequestMutationVariables,
  APITypes.CreateGFTOneNotificationRequestMutation
>;
export const createGFTOneUserSubscription = /* GraphQL */ `mutation CreateGFTOneUserSubscription(
  $input: CreateGFTOneUserSubscriptionRequest!
) {
  createGFTOneUserSubscription(input: $input) {
    id
    status
    app
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGFTOneUserSubscriptionMutationVariables,
  APITypes.CreateGFTOneUserSubscriptionMutation
>;
export const deleteGFTOneUserSubscription = /* GraphQL */ `mutation DeleteGFTOneUserSubscription(
  $input: DeleteGFTOneUserSubscriptionRequest!
) {
  deleteGFTOneUserSubscription(input: $input) {
    id
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteGFTOneUserSubscriptionMutationVariables,
  APITypes.DeleteGFTOneUserSubscriptionMutation
>;
export const updateGFTOneUserSubscription = /* GraphQL */ `mutation UpdateGFTOneUserSubscription(
  $input: UpdateGFTOneUserSubscriptionRequest!
) {
  updateGFTOneUserSubscription(input: $input) {
    id
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGFTOneUserSubscriptionMutationVariables,
  APITypes.UpdateGFTOneUserSubscriptionMutation
>;
export const updateGFTOneUINotification = /* GraphQL */ `mutation UpdateGFTOneUINotification(
  $input: UpdateGFTOneUINotificationRequest!
) {
  updateGFTOneUINotification(input: $input) {
    id
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGFTOneUINotificationMutationVariables,
  APITypes.UpdateGFTOneUINotificationMutation
>;
export const getAllGFTOneUINotifications = /* GraphQL */ `mutation GetAllGFTOneUINotifications($input: GFTOneNotificationsInput) {
  getAllGFTOneUINotifications(input: $input) {
    items {
      id
      app
      channel
      alias
      created_at
      eventType
      stageSystemKey
      seen
      read
      sender
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GetAllGFTOneUINotificationsMutationVariables,
  APITypes.GetAllGFTOneUINotificationsMutation
>;
export const createResource = /* GraphQL */ `mutation CreateResource($input: CreateBindleResourceRequest!) {
  createResource(input: $input) {
    resourceID
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateResourceMutationVariables,
  APITypes.CreateResourceMutation
>;
export const createFpaoneProductsCatalog = /* GraphQL */ `mutation CreateFpaoneProductsCatalog(
  $input: CreateFpaoneProductsCatalogInput!
) {
  createFpaoneProductsCatalog(input: $input) {
    category
    productId
    subCategory
    url
    description
    name
    wiki
    productType
    status
    accessGroups
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFpaoneProductsCatalogMutationVariables,
  APITypes.CreateFpaoneProductsCatalogMutation
>;
export const updateFpaoneProductsCatalog = /* GraphQL */ `mutation UpdateFpaoneProductsCatalog(
  $input: UpdateFpaoneProductsCatalogInput!
) {
  updateFpaoneProductsCatalog(input: $input) {
    category
    productId
    subCategory
    url
    description
    name
    wiki
    productType
    status
    accessGroups
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFpaoneProductsCatalogMutationVariables,
  APITypes.UpdateFpaoneProductsCatalogMutation
>;
export const deleteFpaoneProductsCatalog = /* GraphQL */ `mutation DeleteFpaoneProductsCatalog(
  $input: DeleteFpaoneProductsCatalogInput!
) {
  deleteFpaoneProductsCatalog(input: $input) {
    category
    productId
    subCategory
    url
    description
    name
    wiki
    productType
    status
    accessGroups
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFpaoneProductsCatalogMutationVariables,
  APITypes.DeleteFpaoneProductsCatalogMutation
>;
export const createUserWorkspaceDetails = /* GraphQL */ `mutation CreateUserWorkspaceDetails($input: CreateUserWorkspaceDetailsInput!) {
  createUserWorkspaceDetails(input: $input) {
    userId
    productIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserWorkspaceDetailsMutationVariables,
  APITypes.CreateUserWorkspaceDetailsMutation
>;
export const updateUserWorkspaceDetails = /* GraphQL */ `mutation UpdateUserWorkspaceDetails($input: UpdateUserWorkspaceDetailsInput!) {
  updateUserWorkspaceDetails(input: $input) {
    userId
    productIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserWorkspaceDetailsMutationVariables,
  APITypes.UpdateUserWorkspaceDetailsMutation
>;
export const deleteUserWorkspaceDetails = /* GraphQL */ `mutation DeleteUserWorkspaceDetails($input: DeleteUserWorkspaceDetailsInput!) {
  deleteUserWorkspaceDetails(input: $input) {
    userId
    productIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserWorkspaceDetailsMutationVariables,
  APITypes.DeleteUserWorkspaceDetailsMutation
>;
export const createFPAOneTicket = /* GraphQL */ `mutation CreateFPAOneTicket($input: TicketInput!) {
  createFPAOneTicket(input: $input) {
    ticketyId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFPAOneTicketMutationVariables,
  APITypes.CreateFPAOneTicketMutation
>;
export const createTicket = /* GraphQL */ `mutation CreateTicket($input: CreateTicketInput!) {
  createTicket(input: $input) {
    ticketyId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTicketMutationVariables,
  APITypes.CreateTicketMutation
>;
export const createProduct = /* GraphQL */ `mutation CreateProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    productId
    name
    description
    info
    alias
    subCategoryId
    subCategoryName
    categoryId
    categoryName
    status
    productType
    accessGroups
    ownerGroups
    QUICKSIGHT_DASHBOARD {
      accountId
      namespace
      dashboardId
      props
      __typename
    }
    APLIQO_DASHBOARD {
      url
      props
      __typename
    }
    MICRO_FRONTEND {
      filePath
      exportApp
      props
      __typename
    }
    NATIVE_EXTERNAL {
      url
      props
      __typename
    }
    NATIVE_INTERNAL {
      name
      props
      __typename
    }
    accessType
    fintalkEnabled
    fintalkProps
    requestAccessLink
    featured
    wiki
    poc
    ticketConfig {
      category
      type
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductMutationVariables,
  APITypes.CreateProductMutation
>;
export const updateProduct = /* GraphQL */ `mutation UpdateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    productId
    name
    description
    info
    alias
    subCategoryId
    subCategoryName
    categoryId
    categoryName
    status
    productType
    accessGroups
    ownerGroups
    QUICKSIGHT_DASHBOARD {
      accountId
      namespace
      dashboardId
      props
      __typename
    }
    APLIQO_DASHBOARD {
      url
      props
      __typename
    }
    MICRO_FRONTEND {
      filePath
      exportApp
      props
      __typename
    }
    NATIVE_EXTERNAL {
      url
      props
      __typename
    }
    NATIVE_INTERNAL {
      name
      props
      __typename
    }
    accessType
    fintalkEnabled
    fintalkProps
    requestAccessLink
    featured
    wiki
    poc
    ticketConfig {
      category
      type
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductMutationVariables,
  APITypes.UpdateProductMutation
>;
export const createCategory = /* GraphQL */ `mutation CreateCategory($input: CreateCategoryInput!) {
  createCategory(input: $input) {
    categoryId
    categoryName
    status
    sortOrder
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCategoryMutationVariables,
  APITypes.CreateCategoryMutation
>;
export const updateCategory = /* GraphQL */ `mutation UpdateCategory($input: UpdateCategoryInput!) {
  updateCategory(input: $input) {
    categoryId
    categoryName
    status
    sortOrder
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCategoryMutationVariables,
  APITypes.UpdateCategoryMutation
>;
export const createSubCategory = /* GraphQL */ `mutation CreateSubCategory($input: CreateSubCategoryInput!) {
  createSubCategory(input: $input) {
    subCategoryId
    subCategoryName
    parentCategoryId
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubCategoryMutationVariables,
  APITypes.CreateSubCategoryMutation
>;
export const updateSubCategory = /* GraphQL */ `mutation UpdateSubCategory($input: UpdateSubCategoryInput!) {
  updateSubCategory(input: $input) {
    subCategoryId
    subCategoryName
    parentCategoryId
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubCategoryMutationVariables,
  APITypes.UpdateSubCategoryMutation
>;
export const createSection = /* GraphQL */ `mutation CreateSection($input: CreateResourcesSectionInput!) {
  createSection(input: $input) {
    sectionId
    sectionName
    status
    sortOrder
    createdAt
    createdBy
    updatedAt
    updatedBy
    subsections {
      subsectionId
      subsectionName
      description
      wikiLink
      contentURL
      parentSectionId
      status
      sortOrder
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSectionMutationVariables,
  APITypes.CreateSectionMutation
>;
export const createSubsection = /* GraphQL */ `mutation CreateSubsection($input: CreateResourcesSubsectionInput!) {
  createSubsection(input: $input) {
    subsectionId
    subsectionName
    description
    wikiLink
    contentURL
    parentSectionId
    status
    sortOrder
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubsectionMutationVariables,
  APITypes.CreateSubsectionMutation
>;
export const updateSection = /* GraphQL */ `mutation UpdateSection($input: UpdateResourcesSectionInput!) {
  updateSection(input: $input) {
    sectionId
    sectionName
    status
    sortOrder
    createdAt
    createdBy
    updatedAt
    updatedBy
    subsections {
      subsectionId
      subsectionName
      description
      wikiLink
      contentURL
      parentSectionId
      status
      sortOrder
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSectionMutationVariables,
  APITypes.UpdateSectionMutation
>;
export const updateSubsection = /* GraphQL */ `mutation UpdateSubsection($input: UpdateResourcesSubsectionInput!) {
  updateSubsection(input: $input) {
    subsectionId
    subsectionName
    description
    wikiLink
    contentURL
    parentSectionId
    status
    sortOrder
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubsectionMutationVariables,
  APITypes.UpdateSubsectionMutation
>;
export const updateAboutFPAOne = /* GraphQL */ `mutation UpdateAboutFPAOne($input: UpdateAboutFPAOneInput!) {
  updateAboutFPAOne(input: $input) {
    aboutId
    about
    poc
    accessGroups
    createdAt
    createdBy
    updatedAt
    updatedBy
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAboutFPAOneMutationVariables,
  APITypes.UpdateAboutFPAOneMutation
>;
export const createTicketForProduct = /* GraphQL */ `mutation CreateTicketForProduct($input: CreateTicketForProductInput!) {
  createTicketForProduct(input: $input) {
    ticketyId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTicketForProductMutationVariables,
  APITypes.CreateTicketForProductMutation
>;
export const updateFederateMapping = /* GraphQL */ `mutation UpdateFederateMapping($input: UpdateFederateMappingInput!) {
  updateFederateMapping(input: $input) {
    success
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFederateMappingMutationVariables,
  APITypes.UpdateFederateMappingMutation
>;
export const startConfigQuery = /* GraphQL */ `mutation StartConfigQuery($input: StartConfigQueryInput!) {
  startConfigQuery(input: $input) {
    success
    queryExecutionId
    countQueryExecutionId
    minPeriod
    maxPeriod
    error
    data
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartConfigQueryMutationVariables,
  APITypes.StartConfigQueryMutation
>;
export const createRecord = /* GraphQL */ `mutation CreateRecord($input: CreateRecordInput!) {
  createRecord(input: $input) {
    success
    message
    data
    tableName
    recordId
    error
    notificationsPublished
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRecordMutationVariables,
  APITypes.CreateRecordMutation
>;
export const updateRecord = /* GraphQL */ `mutation UpdateRecord($input: UpdateRecordInput!) {
  updateRecord(input: $input) {
    success
    message
    data
    tableName
    recordId
    error
    notificationsPublished
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRecordMutationVariables,
  APITypes.UpdateRecordMutation
>;
export const deleteRecord = /* GraphQL */ `mutation DeleteRecord($input: DeleteRecordInput!) {
  deleteRecord(input: $input) {
    success
    message
    data
    tableName
    recordId
    error
    notificationsPublished
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRecordMutationVariables,
  APITypes.DeleteRecordMutation
>;
export const generateNewRunModular = /* GraphQL */ `mutation GenerateNewRunModular($input: GenerateNewRunModularInput!) {
  generateNewRunModular(input: $input) {
    success
    message
    runId
    data
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GenerateNewRunModularMutationVariables,
  APITypes.GenerateNewRunModularMutation
>;
export const exportDynamoToS3 = /* GraphQL */ `mutation ExportDynamoToS3($tableName: String!) {
  exportDynamoToS3(tableName: $tableName) {
    success
    message
    runId
    data
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ExportDynamoToS3MutationVariables,
  APITypes.ExportDynamoToS3Mutation
>;
export const precomputeChartDependency = /* GraphQL */ `mutation PrecomputeChartDependency($input: PrecomputeChartDependencyInput!) {
  precomputeChartDependency(input: $input) {
    success
    data
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PrecomputeChartDependencyMutationVariables,
  APITypes.PrecomputeChartDependencyMutation
>;
export const exportForecastToS3 = /* GraphQL */ `mutation ExportForecastToS3($input: ExportForecastToS3Input!) {
  exportForecastToS3(input: $input) {
    success
    presignedUrl
    fileName
    expiresAt
    recordCount
    data
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ExportForecastToS3MutationVariables,
  APITypes.ExportForecastToS3Mutation
>;
export const exportActualsToS3 = /* GraphQL */ `mutation ExportActualsToS3($input: ExportActualsToS3Input!) {
  exportActualsToS3(input: $input) {
    success
    presignedUrl
    fileName
    expiresAt
    recordCount
    data
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ExportActualsToS3MutationVariables,
  APITypes.ExportActualsToS3Mutation
>;
export const computeHierarchicalRollup = /* GraphQL */ `mutation ComputeHierarchicalRollup($input: ComputeHierarchicalRollupInput!) {
  computeHierarchicalRollup(input: $input) {
    success
    data
    queryExecutionId
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ComputeHierarchicalRollupMutationVariables,
  APITypes.ComputeHierarchicalRollupMutation
>;
export const presignQueryResult = /* GraphQL */ `mutation PresignQueryResult($input: PresignQueryResultInput!) {
  presignQueryResult(input: $input) {
    success
    presignedUrl
    fileName
    expiresAt
    recordCount
    data
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PresignQueryResultMutationVariables,
  APITypes.PresignQueryResultMutation
>;
export const putDrrApprovalCsv = /* GraphQL */ `mutation PutDrrApprovalCsv($input: PutDrrApprovalCsvInput!) {
  putDrrApprovalCsv(input: $input) {
    success
    bucket
    key
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PutDrrApprovalCsvMutationVariables,
  APITypes.PutDrrApprovalCsvMutation
>;
export const writeAthenaResultToDynamo = /* GraphQL */ `mutation WriteAthenaResultToDynamo($input: WriteAthenaResultToDynamoInput!) {
  writeAthenaResultToDynamo(input: $input) {
    success
    taskId
    errorCode
    data
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.WriteAthenaResultToDynamoMutationVariables,
  APITypes.WriteAthenaResultToDynamoMutation
>;
